/**
 * Formats a large number into a more readable string with appropriate suffixes.
 * @function formatLargeNumber
 * @param {number} number - The number to format.
 * @returns {string} The formatted number with suffixes (K, M, B).
 */
export function formatLargeNumber(number: number): string {
  if (number >= 1e9) {
    return (number / 1e9).toFixed(1) + 'B';
  } else if (number >= 1e6) {
    return (number / 1e6).toFixed(1) + 'M';
  } else if (number >= 1e4) {
    return (number / 1e3).toFixed(1) + 'K';
  } else if (number >= 1e3) {
    return (number / 1e3).toFixed(1) + 'K';
  } else {
    return number.toString();
  }
}
